// frontend/src/hooks/useServiceWorkerUpdate.js
// Thin React wrapper over serviceWorkerRegistration.js's pub/sub — exposes
// { updateAvailable, applyUpdate } so a banner component can prompt
// "New version available" and let the user choose when to reload, rather
// than the app silently swapping itself out mid-task.
import { useEffect, useState, useCallback, useRef } from 'react';
import { onUpdateAvailable, activateWaitingWorker } from '../serviceWorkerRegistration';

export function useServiceWorkerUpdate() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const registrationRef = useRef(null);

  useEffect(() => {
    return onUpdateAvailable((registration) => {
      registrationRef.current = registration;
      setUpdateAvailable(true);
    });
  }, []);

  const applyUpdate = useCallback(() => {
    activateWaitingWorker(registrationRef.current);
  }, []);

  return { updateAvailable, applyUpdate };
}
